var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "saas_staff_library_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
        "hide-required-asterisk": "",
      },
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v("选择样式")]),
      _c(
        "el-form-item",
        { staticClass: "show_type", attrs: { prop: "show_type" } },
        [
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.typeList, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  class: [
                    "box",
                    item.id == _vm.value.config.show_type && "checked",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeType(item)
                    },
                  },
                },
                [
                  _c("el-image", {
                    staticClass: "img",
                    attrs: { fit: "contain", src: item.imageurl },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "name", label: "楼层名称" } },
        [
          _c("el-input", {
            attrs: { placeholder: "输入10个字以内的名称", clearable: "" },
            model: {
              value: _vm.value.config.name,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "name", $$v)
              },
              expression: "value.config.name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "more_name", label: "查看更多按钮展示为" } },
        [
          _c("el-input", {
            attrs: { placeholder: "输入10个字以内的名称", clearable: "" },
            model: {
              value: _vm.value.config.more_name,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "more_name", $$v)
              },
              expression: "value.config.more_name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "bg_color",
          staticStyle: { "margin-bottom": "0" },
          attrs: { prop: "bg_color", label: "产品展示区背景色" },
        },
        [
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.bg_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "bg_color", $$v)
              },
              expression: "value.config.bg_color",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "module_plate_id", label: "关联职工书屋模块" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "请选择" },
              on: { change: _vm.changeModulePlate },
              model: {
                value: _vm.value.config.module_plate_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "module_plate_id", $$v)
                },
                expression: "value.config.module_plate_id",
              },
            },
            _vm._l(_vm.moduleList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm.value.config.module_plate_id
        ? [
            _c(
              "el-form-item",
              {
                key: "book_type",
                staticStyle: { "margin-bottom": "5px" },
                attrs: { prop: "book_type", label: "书籍类型" },
              },
              [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.changeBookType },
                    model: {
                      value: _vm.value.config.book_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "book_type", $$v)
                      },
                      expression: "value.config.book_type",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "1" } }, [
                      _vm._v("电子书"),
                    ]),
                    _c("el-radio", { attrs: { label: "2" } }, [
                      _vm._v("有声书"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                key: "display_mode",
                staticStyle: { "margin-bottom": "5px" },
                attrs: { prop: "display_mode", label: "书籍展示" },
              },
              [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.changeDisplayMode },
                    model: {
                      value: _vm.value.config.display_mode,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "display_mode", $$v)
                      },
                      expression: "value.config.display_mode",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "1" } }, [
                      _vm._v("按分类展示"),
                    ]),
                    _c("el-radio", { attrs: { label: "2" } }, [
                      _vm._v("自定义展示"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.value.config.display_mode === "1"
              ? _c(
                  "el-form-item",
                  {
                    key: "book_category",
                    attrs: {
                      prop: "book_category",
                      label: "书籍分类",
                      "label-width": "72px",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请选择",
                          "value-key": "id",
                          filterable: "",
                        },
                        on: { change: _vm.changeBookCategory },
                        model: {
                          value: _vm.value.config.book_category,
                          callback: function ($$v) {
                            _vm.$set(_vm.value.config, "book_category", $$v)
                          },
                          expression: "value.config.book_category",
                        },
                      },
                      _vm._l(
                        _vm.value.config.book_type === "1"
                          ? _vm.eBookCategoryList
                          : _vm.aBookCategoryList,
                        function (book_c) {
                          return _c("el-option", {
                            key: book_c.id,
                            attrs: {
                              label: book_c.category_name,
                              value: book_c,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.value.config.display_mode === "2" ||
            _vm.value.config.book_category.id
              ? _c(
                  "el-form-item",
                  {
                    key: "current_book",
                    staticClass: "current_book",
                    attrs: {
                      label:
                        _vm.value.config.display_mode === "1"
                          ? "置顶的书籍"
                          : "选择书籍",
                      prop: "currentBook",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "add-box" },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-key": "id",
                              placeholder:
                                "搜索" +
                                (_vm.value.config.display_mode === "1"
                                  ? ""
                                  : "全部") +
                                "分类下的书籍",
                              filterable: "",
                              remote: "",
                              "remote-method": _vm.remoteBook,
                            },
                            model: {
                              value: _vm.currentBook,
                              callback: function ($$v) {
                                _vm.currentBook = $$v
                              },
                              expression: "currentBook",
                            },
                          },
                          _vm._l(_vm.bookList, function (book) {
                            return _c("el-option", {
                              key: book.book_id,
                              attrs: {
                                label: book.book_name,
                                value: book,
                                disabled: _vm.disabledBook(book.book_id),
                              },
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.addBook },
                          },
                          [_vm._v("添加到列表")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "tips" },
                      [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.value.config.display_mode === "1"
                                  ? "置顶"
                                  : ""
                              ) +
                              "书籍列表（拖动书籍调整顺序）： "
                          ),
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteBook("all")
                              },
                            },
                          },
                          [_vm._v("清空列表")]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "el-form-item",
              { key: "books", staticClass: "books", attrs: { prop: "books" } },
              [
                _c(
                  "draggable",
                  {
                    attrs: { animation: "500", "force-fallback": true },
                    model: {
                      value: _vm.value.config.books,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "books", $$v)
                      },
                      expression: "value.config.books",
                    },
                  },
                  _vm._l(_vm.value.config.books, function (item, index) {
                    return _c(
                      "div",
                      { key: item.book_id, staticClass: "book" },
                      [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(" " + _vm._s(item.book_name) + " "),
                        ]),
                        _c("i", {
                          staticClass: "el-icon el-icon-close",
                          on: {
                            click: function ($event) {
                              return _vm.deleteBook(index)
                            },
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c(
        "el-form-item",
        { attrs: { prop: "margin_top", label: "与上方组件的间距" } },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "z_index", label: "层级高度值" } },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }